import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Header } from 'semantic-ui-react';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import { states } from '@/constants/lifecycle';
import DataManagementDataModelCardItem from './DataManagementDataModelCardItem';
import DataManagementDictionaryCardItems from './DataManagementDictionaryCardItems';

const DataManagementCards = ({
  category,
  code,
  dictionaries,
  hasDataModel,
  itemsPerRow,
}) => (
  <InfiniteScrollCards
    className="aridhia-data-management-cards"
    entity="dictionary"
    icon="table"
    items={dictionaries}
    itemsPerRow={itemsPerRow}
    loading
    readErrors={[]}
    readStatus={[states.SUCCESS]}
  >
    {hasDataModel && (
      <>
        <DataManagementDataModelCardItem category={category} code={code} />
        <Header as="h4"><FormattedMessage id="dataset.dictionary.validation.table.heading" /></Header>
      </>
    )}
    <DataManagementDictionaryCardItems category={category} code={code} dictionaries={dictionaries} />
  </InfiniteScrollCards>
);

export default DataManagementCards;
